<span class="student-score-header--options">
  <mat-radio-group color="primary" aria-label="Select an option">
    <button class="point" aria-label="You have received 1 point">
      <app-shared-point-circle [checked]="score > 0"></app-shared-point-circle>
    </button>
    <button class="point" aria-label="You have received 2 point">
      <app-shared-point-circle [checked]="score > 1"></app-shared-point-circle>
    </button>
    <button class="point" aria-label="You have received 3 point">
      <app-shared-point-circle [checked]="score > 2"></app-shared-point-circle>
    </button>
  </mat-radio-group>
</span>
